import OptionsSummaryLabel from '../../../../../shared/js/components/OptionsSummaryLabel'
import { formatPrice } from '../../../../../shared/js/formatters'
import {
  formatOptionLabel,
  formatOptionsSummary,
  reduceOptionCents,
} from '../../../../../shared/js/options-utils'
import React from 'react'
import type { ProductOptionValueProps } from '../../../../../shared/js/Module'
import type { SyntheticEvent } from 'react'

interface OptionSummaryProps {
  deleteDisabled?: boolean
  id: number
  hidePrice?: boolean
  onCancel?: Function
  values: ProductOptionValueProps[]
}

// Massage selected options to get a user readable summary
export default function OptionSummary({
  deleteDisabled,
  id,
  hidePrice,
  onCancel,
  values,
}: OptionSummaryProps) {
  const { options, selected } = values[0] || {}
  if (!selected || options.length === 0 || !onCancel) {
    return null
  }

  const labels = formatOptionsSummary(options)
  if (labels.length === 0) {
    return null
  }

  const { optionsCents, optionsTaxCents } = reduceOptionCents(undefined, {
    values,
  })

  return labels.map(([title, label], index) => (
    <p className='c-option__label' key={`${title}-${index}`}>
      <small>
        <OptionsSummaryLabel title={title} label={label} />
        {!hidePrice && ` - ${formatPrice(optionsCents + optionsTaxCents)}`}
        {!deleteDisabled && (
          <a
            href='#'
            onClick={handleCancel}
            aria-label={`Supprimer l’option ${formatOptionLabel(label)}`}
            title={`Supprimer l’option ${formatOptionLabel(label)}`}
          >
            (supprimer)
          </a>
        )}
      </small>
    </p>
  ))

  function handleCancel(event: SyntheticEvent) {
    event.preventDefault()
    onCancel?.(id)
  }
}
